import ModalMixin from 'utils/vue/mixins/modal.js'
import CustomMountMixin from '../../../components/_mixins/custom-mount'
import {fv} from '../../../lib/utils'
export default {
  name: 're-se-modal',
  type: 'generic',
  events: 'modal',
  mixins: [ModalMixin, CustomMountMixin],
  props: {
    noCloseButton: {}
  },
  data() {
    return {
      MOUNT_TARGET: this.$$s('globalModal.appendTo.target'),
      MOUNT_CONTAINER: this.$$s(
        'globalModal.appendTo.container',
        '.rocket-effect-container.rocketeffect-global-modal-container.supercharged-entertainment-container'
      ),
      MOUNT_CONTAINER_CLASSES: this.$$s(
        'globalModal.appendTo.classes',
        'rocket-effect-container rocketeffect-global-modal-container supercharged-entertainment-container'
      ),
    }
  },
  computed: {
    hideCloseButton() {
      return fv(this.noCloseButton, this.noClose)
    }
  },
  created() {
    document.addEventListener('keyup', this.keyUp)
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.keyUp)
  }
}

